import axios from "axios";
import { url } from "../utils/urls";

const GetIsPackageManager = async (token) => {
  return axios
    .get(`${url}/api/is_package_manager/`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    })

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default GetIsPackageManager;
